import { openapi } from "../../../../openapi";

const APPADMIN_MIGRATIONS_CACHE_TAG = "AppAdminMigrations";

openapi.enhanceEndpoints({
  addTagTypes: [APPADMIN_MIGRATIONS_CACHE_TAG],
  endpoints: {
    getAppadminMigrations: {
      providesTags: [APPADMIN_MIGRATIONS_CACHE_TAG],
    },
    postAppadminMigrationsRun: {
      invalidatesTags: [APPADMIN_MIGRATIONS_CACHE_TAG],
    },
  },
});
